// Browser-native form navigation, like a rails-ujs data-method link: for actions that
// redirect with a flash message, which axios/XHR breaks (a DELETE 302 is re-followed
// as DELETE and the flash is consumed invisibly).
const submitNavigationForm = (url: string, method: 'post' | 'delete'): void => {
  const form = document.createElement('form')
  form.method = 'post'
  form.action = url

  const addField = (name: string, value: string) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    form.appendChild(input)
  }

  if (method === 'delete') addField('_method', 'delete')

  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute('content')
  if (csrfToken) addField('authenticity_token', csrfToken)

  document.body.appendChild(form)
  form.submit()
}

export default submitNavigationForm
